
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/webinar/ai-transformation-3",
      function () {
        return require("private-next-pages/event/webinar/ai-transformation-3/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/webinar/ai-transformation-3"])
      });
    }
  